export enum Roles {
  AuthAdmin = 'authAdmin',
}
